import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GeoRoutingModule } from './geo-routing.module';
import { AddCitiesComponent } from 'src/app/components/setup/geo/cities/add/add.component';
import { EditCitiesComponent } from 'src/app/components/setup/geo/cities/edit/edit.component';
import { ListCitiesComponent } from 'src/app/components/setup/geo/cities/list/list.component';
import { AddStatesComponent } from 'src/app/components/setup/geo/states/add/add.component';
import { EditStatesComponent } from 'src/app/components/setup/geo/states/edit/edit.component';
import { ListStatesComponent } from 'src/app/components/setup/geo/states/list/list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgbHighlight, NgbNavModule, NgbDropdownModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '../../shared/shared.module';
import { ListPincodeComponent } from 'src/app/components/setup/geo/pincodes/pincodes.component';

@NgModule({
  declarations: [
    ListStatesComponent,
    AddStatesComponent,
    EditStatesComponent,
    ListCitiesComponent,
    AddCitiesComponent,
    EditCitiesComponent,
    ListPincodeComponent
  ],
  imports: [
    CommonModule,
    GeoRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbHighlight,
    NgbNavModule,
    NgbDropdownModule,
    NgSelectModule,
    // DataTablesModule,
    NgbPaginationModule,
    CKEditorModule,
    AgGridModule,
  ],
  exports: [
    ListStatesComponent,
    AddStatesComponent,
    EditStatesComponent,
    ListCitiesComponent,
    AddCitiesComponent,
    EditCitiesComponent,
    ListPincodeComponent
  ],
  providers:[

  ]
})
export class GeoModule { }
